@if ((authenticated | async)==true) {
  <div>
    <a mat-button [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger">
      <mat-icon class="mat-icon-sm">person</mat-icon>
      <span class="show-gt-sm hide-lt-sm mx-1 uppercase">account</span>
      <mat-icon class="mat-icon-sm caret">arrow_drop_down</mat-icon>
    </a>
    <mat-menu #userMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-menu-panel user-menu">
      <span (mouseleave)="userMenuTrigger.closeMenu()">
        <div class="flex-row justify-start items-center" class="user-info">
          <img src="assets/images/others/user.jpg" alt="user-image" width="50">
          <p class="m-0">{{userFullName}}<br> <small><i>{{userRole}}</i></small></p>
        </div>
        <div class="divider"></div>
        @if (isSuperAdmin) {
          <a mat-menu-item routerLink="/account/todo">
            <mat-icon class="mat-icon-sm">whatshot</mat-icon>
            <span class="warn-badge" [matBadge]="toDoCount"
              [matBadgeHidden]="toDoCount == 0"
              matBadgeSize="medium"
              matBadgeColor="warn"
              matBadgeOverlap="false"
              aria-hidden="false"
              aria-label="{{toDoCount}} to do's">To Do</span>
          </a>
        }
        @if (userCanEditInventory) {
          <a mat-menu-item routerLink="/inventory">
            <mat-icon class="mat-icon-sm">input</mat-icon>
            <span>Inventory</span>
          </a>
        }
        @if (userCanEditProperties) {
          <a mat-menu-item routerLink="/account/submit-property">
            <mat-icon class="mat-icon-sm">add_circle</mat-icon>
            <span>Submit Property</span>
          </a>
          <a  mat-menu-item routerLink="/account/admin-properties">
            <mat-icon class="mat-icon-sm">home</mat-icon>
            <span>Active Properties</span>
          </a>
        }
        @if (userCanEditLegalAds) {
          <a  mat-menu-item routerLink="/account/legal-ads">
            <mat-icon class="mat-icon-sm">library_books</mat-icon>
            <span>Legal Ads</span>
          </a>
        }
        @if (userCanEditProperties) {
          <a  mat-menu-item routerLink="/account/schedule">
            <mat-icon class="mat-icon-sm">schedule</mat-icon>
            <span>Schedule</span>
          </a>
        }
        @if (userCanAddUsers) {
          <a  mat-menu-item routerLink="/account/users">
            <mat-icon class="mat-icon-sm">people</mat-icon>
            <span>User Management</span>
          </a>
        }
        @if (userCanEditUserSettings) {
          <a  mat-menu-item routerLink="/account/user-settings">
            <mat-icon class="mat-icon-sm">pages</mat-icon>
            <span>My Settings</span>
          </a>
        }
        @if (userCanEditPlatformSettings) {
          <a  mat-menu-item routerLink="/account/platform-settings">
            <mat-icon class="mat-icon-sm">subject</mat-icon>
            <span>Platform Settings</span>
          </a>
          <a  mat-menu-item routerLink="/account/document-templates">
            <mat-icon class="mat-icon-sm">settings</mat-icon>
            <span>Document Templates</span>
          </a>
        }
        @if (userCanBuyProperties) {
          <a  mat-menu-item routerLink="/account/my-offers">
            <mat-icon class="mat-icon-sm">send</mat-icon>
            <span>My Offers</span>
          </a>
          <a  mat-menu-item routerLink="/account/my-properties">
            <mat-icon class="mat-icon-sm">attach_money</mat-icon>
            <span>My Properties</span>
          </a>
        }
        @if (userRole=='Agent') {
          <a  mat-menu-item routerLink="/account/my-representations">
            <mat-icon class="mat-icon-sm">people</mat-icon>
            <span>My Representations</span>
          </a>
        }
        <a mat-menu-item routerLink="/account/my-documents">
          <mat-icon class="mat-icon-sm">document</mat-icon>
          <span>My Documents</span>
        </a>
        <a mat-menu-item routerLink="/account/favorites">
          <mat-icon class="mat-icon-sm">favorite_border</mat-icon>
          @let favCount = (favoriteProperties | async)?.length ?? 0;
          <span class="warn-badge" [matBadge]="favCount"
            [matBadgeHidden]="!(favCount> 0)"
            matBadgeSize="medium"
            matBadgeColor="warn"
            matBadgeOverlap="false"
            aria-hidden="false"
            aria-label="{{favCount}} favorite properties">Favorites</span>
        </a>
        @if (compareVisible) {
          <a mat-menu-item routerLink="/account/compare">
            <mat-icon class="mat-icon-sm">compare_arrows</mat-icon>
            @let compCount = (comparableProperties | async)?.length ?? 0;
            <span class="warn-badge" [matBadge]="compCount"
              [matBadgeHidden]="!(compCount > 0)"
              matBadgeSize="medium"
              matBadgeColor="warn"
              matBadgeOverlap="false"
              aria-hidden="false"
              aria-label="{{compCount}} compare properties">Compare</span>
          </a>
        }
        <a mat-menu-item routerLink="/account/profile">
          <mat-icon class="mat-icon-sm">edit</mat-icon>
          <span>Edit Profile</span>
        </a>
        <a mat-menu-item routerLink="/faq">
          <mat-icon class="mat-icon-sm">help</mat-icon>
          <span>Help</span>
        </a>
        <div class="divider"></div>
        <a mat-menu-item routerLink="/login" [queryParams]="{ logout: true }">
          <mat-icon class="mat-icon-sm">power_settings_new</mat-icon>
          <span>Sign Out</span>
        </a>
      </span>
    </mat-menu>
  </div>
}
@else {
  <div>
    <a mat-button routerLink="/login">
      <mat-icon class="mat-icon-sm">person</mat-icon>
      <span class="show-gt-sm hide-lt-sm mx-1 uppercase">login</span>
    </a>
  </div>
}

